import React, { useState, useCallback, useEffect } from 'react';
import { getTranslatedText, Loader, SelectionSheet } from '@nile/components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Sheet, Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { useQuery } from '@apollo/client';
import { AccountClient, GET_CLIENTS } from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { constructDataForSelection } from '../../Pebbles/clientVisibility';

function AssociateClients(props) {
  const { intl, clientList } = props;
  const { loading, error, data: allClients } = useQuery(GET_CLIENTS, {
    client: AccountClient,
    variables: {
      listInfo: {}
    }
  });
  const [sheetActive, setSheetActive] = useState(false);
  const [selectedItems, setSelectedItems] = useState(
    constructDataForSelection(clientList, 'accountId')
  );
  useEffect(() => {
    const allItems = constructDataForSelection(clientList, 'accountId');
    setSelectedItems(allItems);
  }, [clientList]);
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );
  if (loading) return <Loader />;
  // Leaving this as such because it would be easier to search and write a common error component for api errors.
  if (error) return <div>error...</div>;
  const { clients } = allClients.getClientList || { clients: [] };
  const sections = [];
  const clientSection = {
    name: 'client',
    header: getTranslatedText(intl, 'admin.Techniciangroup.client.allclients'),
    items: clients.map((el) => {
      return {
        ...el,
        id: el.accountId,
        name: el.name,
        label: el.name
      };
    })
  };

  sections.push(clientSection);
  const updateParent = (items) => {
    props.updateClientList(items);
  };
  return (
    <div>
      <Button icon={<SVGIcon name="Add" />} plain onClick={toggleSheetActive}>
        <FormattedMessage id="admin.customForms.clientVisibility.associateClients" />
      </Button>
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        <SelectionSheet
          sections={sections}
          actions={props.actions}
          meta={{
            heading: getTranslatedText(
              intl,
              'admin.customForms.clientVisibility.sheet.associate'
            ),
            selectedTitle: getTranslatedText(
              intl,
              'admin.Techniciangroup.selectedclients.list'
            )
          }}
          selectedItems={selectedItems}
          toggleSheetActive={toggleSheetActive}
          updateParent={updateParent}
        />
      </Sheet>
    </div>
  );
}

export default injectIntl(AssociateClients);
